import React, { useRef } from 'react';
import GridConfig from './GridConfig';
import CommonGrid from '../../../../../common/GridWithHeader/CommonGrid';

const UsageSummary = ({ data, setSelectedTerminal, userData }) => {
  const gridConfig = useRef(new GridConfig({ userConfig: userData.userProfile?.columnPref }));
  const onRowsSelected = (selectedRows) => {
    const terminal = selectedRows?.[0]?.terminal ?? null;
    setSelectedTerminal(terminal);
  };
  return (
    <CommonGrid
      title="Usage of Dynamic Routing"
      exportFileName="usage_of_dynamic_routing_summary"
      data={data}
      config={gridConfig.current.config}
      onRowsSelected={onRowsSelected}
      gridHeaderConfig={{
        showFullscreen: false
      }}
    />
  );
};

export default UsageSummary;
